import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: alabaster,
    marginTop: indent,
  },
});
